import { STATUS } from '@/constants/status';

export const WORKSPACE_STATUS = STATUS;
